export function activeTabHandler(ActiveTabText) {
  let value;
  switch (ActiveTabText) {
    case "All":
      value = "All";
      break;
    case "Alle":
      value = "All";
      break;
    case "Probes & Connectors":
      value = "Probes & Connectors";
      break;
    case "Sonden & Anschlüsse":
      value = "Probes & Connectors";
      break;
    case "Oxygen Therapy":
      value = "Oxygen Therapy";
      break;
    case "Sauerstoff Therapie":
      value = "Oxygen Therapy";
      break;
    case "Suction":
      value = "Suction";
      break;
    case "Saugen":
      value = "Suction";
      break;
    case "Central Gases":
      value = "Central Gases";
      break;
    case "Zentrale Gase":
      value = "Central Gases";
      break;
    default:
      value = "All";
  }
  return value;
}
